<div [formGroup]="group">
  <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
    <mat-label class="select-label">{{config.label}}</mat-label>
    <input matInput placeholder="{{config.placeholder}}" id="{{config.id}}" [matAutocomplete]="auto" [formControlName]="config.name"  [attr.name]="config.name" (input)='filterOptions($event)' (focus)='filterOptions($event)'>
    <mat-autocomplete id="autonotscroll" #auto="matAutocomplete" (optionSelected)="selected($event)" (closed)="validInput($event)">
      @for (autocompleteOption of autocompleteOptions; track autocompleteOption) {
        <mat-option [value]="autocompleteOption.value" id="{{autocompleteOption.value}}">
          <span [innerHTML]="autocompleteOption.value | highlight: toHighlight"></span>
        </mat-option>
      }
      @if (showNoDataFound) {
        <mat-option>
          <span>{{'common.noDataFound' | translate}}</span>
        </mat-option>
      }
    </mat-autocomplete>
    @if (showErrorText) {
      <mat-error>
        {{ 'common.autoComplteError' | translate }}
      </mat-error>
    }
  </mat-form-field>
</div>